<template>
<div>
  <ul class="list-attachment multi-list">
      <li v-for="(document,index) in configAttachments" v-bind:key="index">
        <Checkbox
          :value="document.checked"
          :disabled="!document.attachment || !document.attachment.document_url"
          @input="selectDocument(document,$event)"
        >
          <span v-if="documentFailed(document)" class="text-red">{{document.display_name}}</span>
          <span v-else>{{document.display_name}}</span>
        </Checkbox>
        <Tooltip v-if="documentFailed(document)"
                 :content="failedDocuments[document.document_code && document.document_code.key].reason || 'Document failed'">
          <span class="action-attach" @click="previewDocument(document.attachment.document_url)">
            <svgicon v-if="document.attachment && document.attachment.document_url"
                     :name="setIcon(document.attachment.document_url)" :original="true"/>
            <svgicon v-else-if="document.attachment"
                     name="pending-document" :original="true"/>
            <span class="empty-text text-red" v-else>
              {{$t('INDENT_NOT_GENERATED')}}
            </span>
          </span>
        </Tooltip>
        <span class="action-attach" @click="previewDocument(document.attachment.document_url)" v-else>
            <svgicon v-if="document.attachment && document.attachment.document_url"
                     :name="setIcon(document.attachment.document_url)" :original="true"/>
            <svgicon v-else-if="document.attachment"
                     name="pending-document" :original="true"/>
            <span class="empty-text" v-else>
              {{$t('INDENT_NOT_GENERATED')}}
            </span>
          </span>
        <span class="ml-15">
          <InputNumber
            v-model="document.default_copies"
            controls-position="right"
            :min="(document.attachment && document.attachment.document_url) ? 1:0"
            :disabled="!document.attachment || !document.attachment.document_url"
            size="small"
            class="no-bg"
            @change="changeDefaultCopies(document,$event,index)">
          </InputNumber>
        </span>
      </li>
    </ul>
</div>
</template>
<script>
import IconMixin from '@common/mixins/IconMixin';
import { keyBy } from 'lodash';

export default {
  props: ['indentDocuments', 'documentConfig', 'printLevel', 'levelId', 'selectedDocuments', 'documentsList', 'defaultCopies', 'selectedConfig', 'failedDocuments'],
  data() {
    return {
      numeric: null,
    };
  },
  mixins: [IconMixin],
  computed: {
    documentsConfig() {
      return this.documentConfig.filter(val => val.print_level === this.printLevel);
    },
    configAttachments() {
      if (this.documentsList) {
        return this.documentsList && this.documentsList.map((document) => {
          const obj = {};
          obj.display_name = this.printLevel === 'carton' ? document.carton_id : document.item_id,
          obj.attachment = document;
          obj.default_copies = document.default_copies || this.defaultCopies;
          obj.type_of_printer = this.selectedConfig && this.selectedConfig.type_of_printer;
          if (obj.attachment && obj.attachment.document_url) {
            const selectedDocIndex = this.selectedDocuments &&
              this.selectedDocuments.findIndex(val =>
                obj.attachment.type === val.type && obj.attachment.delivery_id === val.delivery_id &&
                obj.attachment.carton_id === val.carton_id && obj.attachment.indent_id === val.indent_id &&
                obj.attachment.printing_level === val.printing_level && obj.attachment.item_id === val.item_id,
              );
            obj.checked = (selectedDocIndex !== -1);
          } else {
            obj.checked = false;
          }
          return obj;
        });
      }
      return this.documentsConfig && this.documentsConfig.map((docConfig) => {
        const obj = docConfig;
        obj.attachment = this.indentDocuments &&
          this.indentDocuments.find((val) => {
            if (this.printLevel === 'delivery') {
              return val.type === docConfig.document_code.key && val.delivery_id === this.levelId;
            }
            return val.type === docConfig.document_code.key;
          });
        obj.default_copies = (obj.attachment && obj.attachment.document_url) ? obj.default_copies : 0;
        if (obj.attachment && obj.attachment.document_url) {
          const selectedDocIndex = this.selectedDocuments &&
            this.selectedDocuments.findIndex(val =>
              obj.attachment.type === val.type && obj.attachment.delivery_id === val.delivery_id &&
              obj.attachment.carton_id === val.carton_id && obj.attachment.indent_id === val.indent_id &&
              obj.attachment.printing_level === val.printing_level && obj.attachment.item_id === val.item_id,
            );
          obj.checked = (selectedDocIndex !== -1);
        } else {
          obj.checked = false;
        }
        return obj;
      });
    },
  },
  methods: {
    documentFailed(document) {
      return this.failedDocuments && document &&
        this.failedDocuments[document.document_code && document.document_code.key];
    },
    selectDocument(document, $event) {
      this.$emit('selectDocument', {
        ...document.attachment,
        no_copies: document.default_copies,
        printer_type: document.type_of_printer,
      }, $event);
    },
    previewDocument(s3File) {
      const s3FileSplit = s3File && s3File.split('?')[0];
      if (s3FileSplit && s3FileSplit.endsWith('pdf')) {
        this.$store.dispatch('order/getPreviewUrl', { params: s3File });
      } else {
        alert('Preview is not available for this documents');
      }
    },
    changeDefaultCopies(document, $event, index) {
      if (this.documentsList) {
        this.$emit('changeCopiesNumber', document.attachment, $event, index);
      } else {
        this.$emit('changeCopiesNumber', document.attachment, $event);
      }
    },
  },
};
</script>
